var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24241 6.29631C7.78392 6.55956 6.58178 7.0971 7.31396 7.76974C7.67163 8.09832 8.06997 8.33331 8.57079 8.33331H11.4286C11.9294 8.33331 12.3277 8.09832 12.6854 7.76974C13.4176 7.0971 12.2154 6.55956 11.7569 6.29631C10.6818 5.67898 9.31756 5.67898 8.24241 6.29631Z",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2.91663C11.25 3.60698 10.6904 4.16663 10 4.16663C9.30964 4.16663 8.75 3.60698 8.75 2.91663C8.75 2.22627 9.30964 1.66663 10 1.66663C10.6904 1.66663 11.25 2.22627 11.25 2.91663Z",
    stroke: "#2177FE",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6594 16.2963C13.2009 16.5596 11.9988 17.0971 12.731 17.7697C13.0886 18.0983 13.487 18.3333 13.9878 18.3333H16.8456C17.3464 18.3333 17.7447 18.0983 18.1024 17.7697C18.8346 17.0971 17.6324 16.5596 17.1739 16.2963C16.0988 15.679 14.7346 15.679 13.6594 16.2963Z",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 12.9166C16.6665 13.607 16.1069 14.1666 15.4165 14.1666C14.7261 14.1666 14.1665 13.607 14.1665 12.9166C14.1665 12.2263 14.7261 11.6666 15.4165 11.6666C16.1069 11.6666 16.6665 12.2263 16.6665 12.9166Z",
    stroke: "#2177FE",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8259 16.2963C2.36741 16.5596 1.16528 17.0971 1.89746 17.7697C2.25512 18.0983 2.65347 18.3333 3.15429 18.3333H6.01206C6.51287 18.3333 6.91122 18.0983 7.26888 17.7697C8.00106 17.0971 6.79893 16.5596 6.34044 16.2963C5.26529 15.679 3.90106 15.679 2.8259 16.2963Z",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 12.9166C5.83301 13.607 5.27336 14.1666 4.58301 14.1666C3.89265 14.1666 3.33301 13.607 3.33301 12.9166C3.33301 12.2263 3.89265 11.6666 4.58301 11.6666C5.27336 11.6666 5.83301 12.2263 5.83301 12.9166Z",
    stroke: "#2177FE",
    strokeWidth: 1.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 10.8333V12.9166M9.99984 12.9166L12.0832 14.1666M9.99984 12.9166L7.9165 14.1666",
    stroke: "#2177FE",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/hierarchy.15124f6b179b56fc94945eedb5a8a0c9.svg";
export { ForwardRef as ReactComponent };